import {isFilled} from '@prismicio/client'
import type {CarouselSliceEventHero} from 'prismicio-types'
import type {FC} from 'react'
import {Container} from 'src/common/Container'
import {EventHeroSlider} from './components/EventHeroSlider'

type EventHeroProps = {
  slice: CarouselSliceEventHero & {
    slice_type: string
    variation: string
  }
  componentIndex: number
}

export const EventHero: FC<EventHeroProps> = ({slice}) => {
  const {title, events, duration} = slice.primary

  if (!events || events.length === 0) {
    return null
  }

  return (
    <Container
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="pt-[96px] max-md:!pb-0 md:pt-[120px]"
      backgroundColor="Grey/100"
    >
      <div
        className="grid-base mx-auto gap-8 px-5 md:gap-12 md:px-10 lg:px-5 xl:px-0"
        data-slice-type={slice.slice_type}
        data-slice-variation={slice.variation}
      >
        {isFilled.keyText(title) && (
          <div className="col-span-full flex w-full items-center">
            <h1 className="text-[36px] font-medium leading-normal tracking-[-0.36px] text-moss-black lg:text-48 lg:tracking-[-0.48px]">
              {title}
            </h1>
          </div>
        )}

        <div className="col-span-full">
          <EventHeroSlider events={events} duration={duration} />
        </div>
      </div>
    </Container>
  )
}
